import React from 'react';
import { isMobile } from '@pascal/pascal-core';

export function LiveBetsWr({ InnerComp }) {
  if (isMobile()) {
    return (
      <div className='mobile-bet-content-wrp'>
        <div className='mobile-bet-content-inner'>
          <InnerComp />
        </div>
      </div>
    );
  }
  return (
    <div className='tb-left-combinations-table'>
      <div className='tb-left-comb-table-wrp'>
        <InnerComp />
      </div>
    </div>
  );
}
